export { default } from './lib/icon-link.vue';
